import { render, staticRenderFns } from "./DeleteEvent.vue?vue&type=template&id=088ee1a1&scoped=true&"
import script from "./DeleteEvent.vue?vue&type=script&lang=js&"
export * from "./DeleteEvent.vue?vue&type=script&lang=js&"
import style0 from "./DeleteEvent.vue?vue&type=style&index=0&id=088ee1a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088ee1a1",
  null
  
)

export default component.exports